<template>
    <c-dialog ref="dialog" title="授信还款单详情" mode="slide" width="85vw" enable-flex mask-close :button="false">
        <template #head>
            <div v-if="detailData.record_no" class="m-detail-tag flex-center-cross">
                <label>{{detailData.record_no}}</label>
                <c-state async tag dict="AUDIT_STATE" :value="detailData.state"></c-state>
            </div>
        </template>

        <module>
            <module-col size="310">
                <c-detail class="m-detail-form">
                    <c-detail-item label="还款客户">
                        <strong>{{detailData.customer_name}}</strong>
                    </c-detail-item>
                    <c-detail-item label="还款单号">
                        {{detailData.record_no}}
                    </c-detail-item>
                    <c-detail-item label="审核状态">
                        <c-state async tag dict="AUDIT_STATE" :value="detailData.state"></c-state>
                    </c-detail-item>
                    <c-detail-item label="还款方式">
                        <c-state v-if="detailData.pay_type != null" async dict="WITHDRAW_PAY_TYPE" tag :value="detailData.pay_type"></c-state>
                        <span v-else>-</span>
                    </c-detail-item>
                    <c-detail-item label="单据数量">
                        {{detailData.order_count||0}}
                    </c-detail-item>
                    <c-detail-item label="还款金额">
                        <strong style="color: red">￥{{detailData.repayment_amount||0}}</strong>
                    </c-detail-item>
                    <c-detail-item label="备注">
                        {{detailData.remark||'-'}}
                    </c-detail-item>
                    <c-detail-item label="创建人">
                        {{detailData.create_user_realname}}
                    </c-detail-item>
                    <c-detail-item label="创建时间">
                        {{detailData.create_date}}
                    </c-detail-item>
                    <c-detail-item label="审核人">
                        {{detailData.audit_user_realname||'-'}}
                    </c-detail-item>
                    <c-detail-item label="审核时间">
                        {{detailData.audit_date||'-'}}
                    </c-detail-item>
                    <c-detail-item label="审核备注">
                        {{detailData.audit_remark||'-'}}
                    </c-detail-item>
                    <c-detail-item label="还款凭证">
                        <template #default="{data}">
                            <c-file v-if="detailData.voucher_img_url" :src="detailData.voucher_img_url"></c-file>
                            <span v-else>-</span>
                        </template>
                    </c-detail-item>
                </c-detail>
            </module-col>

            <module-col tab-type="border-tab">
                <!--核销商品明细-->
                <module-tab name="授信支付详情" enable-flex>
                    <div class="m-detail-box">
                        <c-table ref="billList" border :paging="false">
                            <c-table-column
                                    name="order_no"
                                    label="订单号"
                                    width="130"
                            >
                            </c-table-column>

                            <c-table-column
                                    label="商品信息"
                                    width="280"
                            >
                                <template #default="{data}">
                                    <c-state v-if="data.level_type" tag async dict="LEVEL_TYPE" :value="data.level_type"></c-state>
                                    <span>{{data.product_name}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    name="produce_code"
                                    label="背贴码"
                                    width="130"
                            >
                            </c-table-column>

                            <c-table-column
                                    name="imei"
                                    label="IMEI码"
                                    width="130"
                            >
                            </c-table-column>
                            <c-table-column label="售卖类型" width="100">
                                <template #default="{data}">
                                    <!--拆机行悬停动态查询拆机项详情（与授信账单/线下订单列表同口径）-->
                                    <c-tooltip v-if="data.sell_type == 2" position="bottom" color="white" @mouseenter.native="loadDismantleItems(data)">
                                        <span class="sell-type-dismantle">
                                            <c-state async dict="SALE_SELL_TYPE" tag :value="data.sell_type"></c-state>
                                            <i class="tf tf-detail"></i>
                                        </span>
                                        <template #tip>
                                            <p v-if="getDismantleState(data).loading" class="m-dismantle-item">正在查询拆机项...</p>
                                            <p v-else-if="getDismantleState(data).error" class="m-dismantle-item">{{getDismantleState(data).error}}</p>
                                            <template v-else>
                                                <p v-for="(item, index) in getDismantleState(data).items" :key="index" class="m-dismantle-item">{{item}}</p>
                                                <p v-if="!getDismantleState(data).items.length" class="m-dismantle-item">暂无拆机项</p>
                                            </template>
                                        </template>
                                    </c-tooltip>
                                    <c-state v-else async dict="SALE_SELL_TYPE" tag :value="data.sell_type"></c-state>
                                </template>
                            </c-table-column>
                            <c-table-column label="交易金额" width="100">
                                <template #default="{data}">
                                    <span style="color: green">￥{{data.sale_price||0}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="退款金额" width="100">
                                <template #default="{data}">
                                    <span style="color: red">￥{{data.after_sale_amount||0}}</span>
                                </template>
                            </c-table-column>
                            <!--退款中金额：已申请售后但尚未完成退款-->
                            <c-table-column label="退款中" width="100">
                                <template #default="{data}">
                                    <span style="color: #dd6b20">{{Number(data.refunding_amount || 0) > 0 ? '￥' + data.refunding_amount : '-'}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="当前欠款" width="100">
                                <template #default="{data}">
                                    <span style="color: green;" v-if="data.credit_bill_state != 3">￥{{data.debt_amount||0}}</span>
                                    <span v-else>-</span>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    name="create_user_realname"
                                    label="下单人"
                                    width="130"
                            >
                            </c-table-column>
                            <c-table-column
                                    name="create_date"
                                    label="下单时间"
                                    width="130"
                            >
                            </c-table-column>
                        </c-table>
                    </div>
                </module-tab>
            </module-col>
            <template #button v-if="detailData.state == 1">
                <c-button v-if="auth('b_credit_repayment_audit')" color="main" size="dialog" @click="$refs.auditDialog.open()">还款审核</c-button>
                <c-button color="green" size="dialog" @click="openAllinpayPay">通联付款</c-button>
            </template>

            <!--还款单审核弹窗-->
            <c-dialog ref="auditDialog" title="还款单审核" width="500" @resolve="handleAudit">
                <c-form ref="auditForm" unit-width="100%">
                    <c-form-item label="审核结果" required>
                        <c-radio-group name="state" :options="stateDic" v-model="state"></c-radio-group>
                    </c-form-item>
                    <c-form-item label="还款凭证" v-if="state == 2" required>
                        <c-upload-file filePath="quote" name="voucher_img_url" type="image"></c-upload-file>
                    </c-form-item>
                    <c-form-item label="审核备注" required>
                        <c-input type="textarea" name="audit_remark" maxlength="500" placeholder="请输入信息信息"></c-input>
                    </c-form-item>
                </c-form>
            </c-dialog>
        </module>
    </c-dialog>
</template>

<script>
import {mapState} from 'vuex';
import {asyncMapState} from '@/store';

export default {
    name: 'creditRepaymentDetail',

    components: {
    },

    props: {
        id: [String, Number]
    },

    data() {
        return {
            detailData: {},
            billList: [],                   //关联授信账单列表（通联付款弹窗展示用）
            //审批结果
            stateDic: [
                {name: '审批通过',value: 2,color: 'blue'},
                {name: '审批驳回',value: 3,color: 'red'},
            ],
            state:2,         //审批状态
            /**售卖类型列悬停拆机项查询状态：key=order_id，每次悬停实时查询不跨次复用 */
            dismantleMap: {}
        }
    },

    computed: {
        ...asyncMapState(['DISMANTLE_ITEM'])
    },

    methods: {
        /*********获取产品信息文字**********/
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.model_name) parts.push(data.model_name);
            if (data.color_name) parts.push(data.color_name);
            if (data.memory_name) parts.push(data.memory_name);
            return parts.join(' ') || '-';
        },

        /*********悬停售卖类型列：实时查询该订单商品的拆机项**********/
        loadDismantleItems(data) {
            if (data.sell_type != 2) return;
            var key = data.order_id;
            var state = this.dismantleMap[key];
            // 在途请求未返回前不重复发起，避免鼠标移动抖动产生并发查询
            if (state && state.loading) return;
            this.$set(this.dismantleMap, key, {
                loading: true,
                error: '',
                products: []
            });
            this.request({
                url: '/offline/sale/order/dismantleItems',
                data: {
                    order_no: data.order_no
                },
                fail: (code, obj, msg) => {
                    // 悬停查询失败不弹全局提示，错误信息在浮层内展示
                    this.$set(this.dismantleMap, key, {
                        loading: false,
                        error: msg || '拆机项查询失败',
                        products: []
                    });
                    return false;
                },
                success: result => {
                    this.$set(this.dismantleMap, key, {
                        loading: false,
                        error: '',
                        products: (result && result.products) || []
                    });
                }
            });
        },

        /*********获取当前行拆机项浮层状态（查询中/失败/拆机项名称列表）**********/
        getDismantleState(data) {
            var state = this.dismantleMap[data.order_id] || {};
            var items = [];
            if (!state.loading && !state.error) {
                // 接口按订单号返回全部商品，取当前行商品（列表行 id 即订单商品ID）的拆机项
                var product = (state.products || []).find(item => item.id == data.id);
                items = this.formatDismantleItems(product ? product.dismantle_items : '');
            }
            return {
                loading: !!state.loading,
                error: state.error || '',
                items: items
            };
        },

        /*********解析拆机项并按字典翻译显示名称（存储为字典value数组，与开单页口径一致）**********/
        formatDismantleItems(value) {
            if (!value) return [];
            var list = value;
            if (typeof list == 'string') {
                try {
                    list = JSON.parse(list);
                } catch (e) {
                    return [value];
                }
            }
            if (!Array.isArray(list)) return [];
            var dict = this.DISMANTLE_ITEM || [];
            return list.map(item => {
                // 数组项为字典value或{value,name}对象，统一取value后翻译为字典名称展示
                var val = String(item && item.value ? item.value : item);
                var option = dict.find(dic => String(dic.value) == val);
                return option ? option.name : val;
            }).filter(item => item);
        },
        /**
         * 加载详情
         */
        detail(){
            this.request({
                url: '/order/credit/repayment/detail',
                data: {
                    repayment_id: this.id
                },
                loading: true,
                success: data => {
                    this.detailData = data.repayment_order_detail;
                    this.billList = data.bill_list || [];
                    this.$refs.billList.setData(data.bill_list);
                }
            });
        },
        open() {
            this.detail();
            this.$refs.dialog.open();
        },
        /******打开通联扫码付款弹窗（先预校验，未开通通联账户等异常仅报错，不弹支付弹窗）*******/
        openAllinpayPay() {
            this.request({
                url: '/order/credit/repayment/consume/check',
                data: {
                    repayment_id: this.id
                },
                loading: true,
                success: data => {
                    this.globalDialog('creditRepaymentPay', {
                        props: {
                            id: this.id,
                            record_no: data.record_no,
                            amount: data.repayment_amount,
                            orders: this.billList
                        }
                    }, () => {
                        //支付成功后刷新还款单详情（状态、备注、审核时间）
                        this.detail();
                        //同步刷新授信还款单列表/授信账单列表（globalDialog resolve 回调）
                        this.$emit('resolve');
                    });
                }
                //失败时组件库默认弹出后端透出的错误信息（如：当前登录账号未开通通联账户），不打开支付弹窗
            });
        },
        /******还款单审核*******/
        handleAudit(stop, next) {
            stop();
            this.$refs.auditForm.submit({
                url: '/order/credit/repayment/audit',
                rule: {
                    state: '请选择审核结果',
                    voucher_img_url: [{
                        type: 'empty',
                        message: '请选择还款凭证',
                        skip: () => {
                            return this.state == 3;
                        }
                    }],
                    audit_remark: [{
                        type: 'empty',
                        message: '请输入审核备注信息',
                        skip: () => {
                            return this.state == 3;
                        }
                    }]
                },
                dataFormatter: (data) => {
                    data.repayment_id = this.id
                    return data;
                },
                success: () => {
                    next();
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    this.$refs.dialog.close();
                    //回调函数
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
    .logs-list {
        padding: 10px 10px;

        li {
            padding: 4px 0;
            line-height: 16px;
            font-size: 13px;
            color: #666;
        }
    }
    /* 拆机售卖类型：标签+详情图标 */
    .sell-type-dismantle {
        display: inline-flex;
        align-items: center;
        gap: 2px;

        .tf-detail {
            font-size: 12px;
            color: #ff6900;
            cursor: help;
        }
    }

    .m-dismantle-item {
        margin: 0;
        line-height: 20px;
    }
</style>